import React, { useEffect, useState, useContext, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ACTIONS, AuthRoutes, SELECTED_TAB_KEY, TOAST_TYPE, USERTYPES } from "../../constants/Constants";
import { useTranslation } from "react-i18next";
import { getPacsQueueList, refreshQueueItem, cancelQueueItem, swapQueueItemPriority } from "../../service/PacsQueueService";
import { t } from "i18next";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import userContext from "../../context/users/UserContext";
import { PrimaryButton, SearchBox, TextField } from "@fluentui/react";
import CustomMultiSelect from "../../components/CustomMultiSelect";
import loaderContext from "../../context/loader/LoaderContext";
import ColumnsPacsQueue from "./ColumnsPacsQueue";
import toastContext from "../../context/toast/ToastContext";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { pacsQueueInitialState } from "./Helper";

const PacsQueueList = (props) => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const { roles, loadByUsername, authenticated } = useContext(userContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [dataQueryState, setDataQueryState] = useState({});
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);
  const [pacsQueueFilterObj, setpacsQueueFilterObj] = useState(
    pacsQueueInitialState
  );
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const { showToastv2 } = useContext(toastContext);
  const [isInitialCall, setIsInitialCall] = useState(true);
  const [status, setStatus] = useState([0,1]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [queueId, setQueueId] = useState(null);
  const [listViewLoading,setListViewLoading] = useState(false);
  const listViewRef = useRef(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [destinationOptions, setDestinationOptions] = useState([]);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  // Auto-refresh logic
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     ReloadList();
  //   }, 15000); 
  //   return () => clearInterval(interval);
  // }, []);
  

  useEffect(() => {
    console.log("Selected value:", props.selectedValue);
    console.log("isInitialCall:", isInitialCall);
    if(props.selectedValue == SELECTED_TAB_KEY.PACSQUEUE + '1'){
      setStatus([0, 1]);
    } else if(props.selectedValue == SELECTED_TAB_KEY.PACSQUEUE + '2'){
      setStatus([3, 4]);
    } else if(props.selectedValue == SELECTED_TAB_KEY.PACSQUEUE + '3'){
      setStatus([2, 5]);
    }
  
    if (isInitialCall) {
      setIsInitialCall(false); 
    } else {
      setpacsQueueFilterObj(pacsQueueInitialState);
      setDisplayListAppliedFilter([]);
      setPagination(() => {
        const newItem = { ...paginationObj };
        newItem.pageIndex = 0;
        return newItem;
      });

      setTimeout(() => {
        setFilterObj(() => {
          const newItem = { ...filterObj };
          newItem.filterInput = null;
          newItem.filterUpdate = newItem.filterUpdate + 1;
          return newItem;
        });
      }, 100);
      
    }
  }, [props.selectedValue]);

  const fetchPacsQueueList = async (options) => {
    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 20,
        filterInput:
          options.filterObj.filterInput == null||
          options.filterObj.filterInput == ''
            ? null
            : options.filterObj.filterInput,
        destination:
            pacsQueueFilterObj.destination?.length > 0
              ? pacsQueueFilterObj.destination
              : null,
        patientId:
            pacsQueueFilterObj.patientId == null ||
            pacsQueueFilterObj.patientId == ''
              ? null
              : pacsQueueFilterObj.patientId,
        patientName:
            pacsQueueFilterObj.patientName == null ||
            pacsQueueFilterObj.patientName == ''
              ? null
              : pacsQueueFilterObj.patientName,
        status: status == null || status == undefined 
              ? [0,1] 
              : status,
        jobId:
            pacsQueueFilterObj.jobId == null
              ? null
              : pacsQueueFilterObj.jobId,
        clientNames:
            pacsQueueFilterObj.clientNames?.length > 0
              ? pacsQueueFilterObj.clientNames
              : null,
      },
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    //setListViewLoading(true);
    //listViewRef.current.continuousStart();

    try {
      const response = await getPacsQueueList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
       // setListViewLoading(false);
       // listViewRef.current.complete();
        data = response.data.data.results.content;
        pageCount = response.data.data.results.totalPages;
        const responseData = response.data.data;
        if (responseData.clients) {
          const seen = new Set();
          const uniqueOptions = responseData.clients
            .map(c => ({ key: c.name, text: c.name }))
            .filter(o => seen.has(o.key) ? false : seen.add(o.key));
          setClientOptions(uniqueOptions);
        }
        if (responseData.destinations) {
          const seen = new Set();
          const uniqueOptions = responseData.destinations
            .map(d => ({ key: d.name, text: d.name }))
            .filter(o => seen.has(o.key) ? false : seen.add(o.key));
          setDestinationOptions(uniqueOptions);
        }
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
         setLoaderRunning(false);
        ref.current.complete();
        //setListViewLoading(false);
       // listViewRef.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      console.log(e);
       setLoaderRunning(false);
     // setListViewLoading(false);
    }
  };

  function ReloadList() {
    setFilterObj((prevFilterObj) => ({
      ...prevFilterObj,
      filterUpdate: prevFilterObj.filterUpdate + 1,
    }));
  }

  function ReloadRow(updatedItem, index) {
    setDataQueryState((prevState) => {
      const newRows = [...prevState.data.rows];
      newRows[index] = updatedItem;
      return {
        ...prevState,
        data: {
          ...prevState.data,
          rows: newRows
        }
      };
    });
  }

  const handleRefreshQueueItem = async (event, data, cell) => {
    console.log("refresh clicked", cell);
    event.stopPropagation();
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await refreshQueueItem(cell.row.original.id);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        const updatedItem = response.data.data;
        ReloadRow(updatedItem, cell.row.index);
        showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
      } else if (response.data.result === "FAILURE") {
        showToastv2(TOAST_TYPE.SUSPECT, response.data.message);
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Some error occurred!");
      }
      setLoaderRunning(false);
    } catch (e) {
      console.error("Error refreshing queue item:", e);
      setLoaderRunning(false);
    }
  };

  const handleConfirmationPopup = (event, data, cell) => {
    event.stopPropagation();
    setQueueId(cell.row.original.id);
    setShowConfirmModal(true);
  }

  const handleConfirmCloseModal = () =>{
    setShowConfirmModal(false);
  }

  const handleCancelQueueItem = async () => {
    console.log("cancel clicked", queueId);
    //event.stopPropagation();
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await cancelQueueItem(queueId);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        const updatedItem = response.data.data;
        ReloadRow(updatedItem);
        showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
      } else if (response.data.result === "FAILURE") {
        showToastv2(TOAST_TYPE.SUSPECT, response.data.message);
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Some error occurred!");
      }
      setShowConfirmModal(false);
      setLoaderRunning(false);
    } catch (e) {
      console.log(e);
      setShowConfirmModal(false);
      setLoaderRunning(false);
    }
  };

  const handlePriorityUp = async (event, cell) => {
    event.stopPropagation();
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await swapQueueItemPriority(cell.row.original.id, "up");
    console.log("Priority up", response);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      //const updatedItem = response.data.data;
      ReloadList();
      showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
    } else if (response.data.result === "FAILURE") {
      showToastv2(TOAST_TYPE.SUSPECT, response.data.message);
    } else {
      showToastv2(TOAST_TYPE.ERROR, "Some error occurred!");
    }
    setLoaderRunning(false);
  };

  const handlePriorityDown = async (event, cell) => {
    event.stopPropagation();
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await swapQueueItemPriority(cell.row.original.id, "down");
      console.log("Priority down", response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        ReloadList();
        showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
      } else if (response.data.result === "FAILURE") {
        showToastv2(TOAST_TYPE.SUSPECT, response.data.message);
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Some error occurred!");
      }
      setLoaderRunning(false);
    } catch (e) {
      console.log(e);
      setLoaderRunning(false);
    }
  };

  const handleApplyClick = (filterValue) => {
    if (filterValue != undefined) filterValue = filterValue.trim();
    const transformedArray = Object.keys(pacsQueueFilterObj)
      .map((key) => {
        let val = pacsQueueFilterObj[key];
        if (key === "clientNames" && Array.isArray(val)) {
          return val.map(clientName => ({ key, label: String(clientName) }));
        }
        if (key === "destination" && Array.isArray(val)) {
          return val.map(dest => ({ key, label: String(dest) }));
        }
        return { key, label: val != null ? String(val) : null };
      })
      .flat().filter((item) => item && item.label != null && item.label !== "");
    console.log('--- Handle Apply Click ---', transformedArray);

    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        if (filterValue != null) {
          newItem.filterInput = filterValue;
        }
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const filterList = (searchInput) => {
    console.log('--- Filter function TODO ---');
  };

  const handleClearFilter = () => {
    console.log('---- Clear Filter Clicked ----');
    setpacsQueueFilterObj(pacsQueueInitialState);
    setDisplayListAppliedFilter([]);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = null;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const removeBadgeFromFilter = (toBeRemoveObj) => {
    console.log('--- Updating RemoveBadgeFromFilter ----', toBeRemoveObj);
    setpacsQueueFilterObj((currentpacsQueueFilterObj) => {
      const updatedpacsQueueFilterObj = { ...currentpacsQueueFilterObj };

      if (updatedpacsQueueFilterObj.hasOwnProperty(toBeRemoveObj.key)) {
        const currentValue = currentpacsQueueFilterObj[toBeRemoveObj.key];
        updatedpacsQueueFilterObj[toBeRemoveObj.key] = Array.isArray(currentValue)
          ? currentValue.filter((item) => item !== toBeRemoveObj.label)
          : null;
      } else {
        console.error(
          `Key "${toBeRemoveObj.key}" does not exist in pacsQueueInitialState.`
        );
      }
      return updatedpacsQueueFilterObj;
    });

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const columns = ColumnsPacsQueue(handleRefreshQueueItem, handleConfirmationPopup, handlePriorityUp, handlePriorityDown);

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <PrimaryButton
          text={t("button.refresh")}
          className={"common-default-active-button list-view-top-buttons-styles"}
          onClick={ReloadList}
        />
      ),
    },
  ];

  return (
    <>
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={[]}
        fetchData={fetchPacsQueueList}
        showSideBySide={false}
        columns={columns}
        handleUserClick={() => { console.log("clicked") }}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        // sortObj={sortObj}
        // setSortObj={setSortObj}
        setPagination={setPagination}
        handleApplyClick={handleApplyClick}
        paginationObj={paginationObj}
        unqiueKey={"PacsQueue"}
        placeholder={t("placeholder.order-id-search")}
        //heading={t("navbar.pacs-queue")}
        tabHeaderPresent={true}
        pointer={false}
        fullLength={true}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        enhancedFilter={true}
        showSort={false}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        filterPopUpComponent={
          <FilterPopUpComponent
            pacsQueueFilterObj={pacsQueueFilterObj}
            setpacsQueueFilterObj={setpacsQueueFilterObj}
            clientOptions={clientOptions}
            destinationOptions={destinationOptions}
          />
        }
        //listViewLoading={listViewLoading}
        //listViewRef={listViewRef}
        //setListViewLoading={setListViewLoading}
      />

      {showConfirmModal &&
          <ConfirmModal handleConfirm={handleCancelQueueItem} handleNotConfirm={handleConfirmCloseModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message="Do you really want to cancel this job? Once cancelled, it won't be recovered."
          title="Confirm Cancel Queue" confirmButtonText={t("confirm-message.yes")} cancelButtonText={"Cancel"}/>
      }

    </>
  );
};

export default PacsQueueList;

const FilterPopUpComponent = ({
  pacsQueueFilterObj,
  setpacsQueueFilterObj,
  clientOptions,
  destinationOptions,
}) => {  

  return (
    <div style={{ display: 'flex' , marginBottom : "10px"}}>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          Patient ID
        </span>
        <TextField
          name="Patient Id"
          placeholder={t('placeholder.search')}
          value={pacsQueueFilterObj.patientId}
          onChange={(ev) => {
            setpacsQueueFilterObj({
              ...pacsQueueFilterObj,
              patientId: ev.target.value,
            });
          }}
          styles={{ backgroundColor: '#2e3033' }}
        />
        <span className="filter-section-text" style={{marginTop : "5px"}}>
          Patient Name
        </span>
        <TextField
          name="Patient Name"
          placeholder={t('placeholder.search')}
          value={pacsQueueFilterObj.patientName}
          onChange={(ev) => {
            setpacsQueueFilterObj({
              ...pacsQueueFilterObj,
              patientName: ev.target.value,
            });
          }}
          styles={{ 
  fieldGroup: { 
    
    height: '32px',
    display: 'block'
  },
   field: {
      paddingTop: '6px' // Optional: fine-tune position
    }
  
}}
        />
      </div>

      <div className="filter-section-seperator"></div>

      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          Destination
        </span>
        <CustomMultiSelect        
          options={destinationOptions}
          placeholder="Select destination"
          searchPlaceholder="Search destinations"
          selectedKeys={pacsQueueFilterObj.destination || []}
          setSelectedKeys={(keys) => {
            setpacsQueueFilterObj({
              ...pacsQueueFilterObj,
              destination: keys || [],
            });
          }}
          calloutProps={{ doNotLayer: true }}
          showSelectAll={true}
          styles={{
            root: { marginTop: 0 },
            title: { marginBottom: 0 },
          }}
        />
        <span className="filter-section-text" style={{marginTop : "5px"}}>
          Job Id
        </span>
        <TextField
          name="Job Id"
          placeholder={t('placeholder.search')}
          value={pacsQueueFilterObj.jobId}
          onChange={(ev) => {
            setpacsQueueFilterObj({
              ...pacsQueueFilterObj,
              jobId: ev.target.value,
            });
          }}
          styles={{ backgroundColor: '#2e3033' }}
        />
      </div>

      <div className="filter-section-seperator"></div>

      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          Client
        </span>
        <CustomMultiSelect
          options={clientOptions}
          placeholder="Select clients"
          searchPlaceholder="Search clients"
          selectedKeys={pacsQueueFilterObj.clientNames || []}
          setSelectedKeys={(keys) => {
            setpacsQueueFilterObj({
              ...pacsQueueFilterObj,
              clientNames: keys || [],
            });
          }}
          showSelectAll={true}
        />
      </div>

    </div>
  );
};
